/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { useContext } from 'react';
import { MENU_ID_DASHBOARDS_VIEW_ALL } from '@jira/navigation-apps__sidebar-nav4-context/src/common/constants.tsx';
import type { NavSubmenuFooter } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/types.tsx';
import { ViewAllEntityMenuItem } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/ui/view-all-entity-menu-item/index.tsx';
import { dashboardsDirectoryRoute } from '@jira/router-routes__directories-routes/src/dashboardsDirectoryRoute.tsx';
import { MenuList } from '@atlaskit/side-nav-items/menu-list';
import { MenuListItem } from '@atlaskit/side-nav-items/menu-list-item';
import { MenuSection } from '@atlaskit/side-nav-items/menu-section';
import { useIntl, defineMessage } from '@atlassian/jira-intl';
import { AnalyticContext } from '../../controllers/analytic-context/index.tsx';

const viewAllDashboards = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-content-dashboards.common.footer.view-all-dashboards',

	defaultMessage: 'View all dashboards',
	description: 'Message for the view all dashboards menu item in the dashboards submenu',
});

const VIEW_ALL_DASHBOARDS_HREF = dashboardsDirectoryRoute.path;

export const Footer: NavSubmenuFooter = ({ onClose }) => {
	const { formatMessage } = useIntl();

	const { fireUIAnalyticForFixMenuItem } = useContext(AnalyticContext);

	return (
		<MenuListItem>
			<MenuSection>
				<MenuList>
					<ViewAllEntityMenuItem
						href={VIEW_ALL_DASHBOARDS_HREF}
						menuId={MENU_ID_DASHBOARDS_VIEW_ALL}
						onClick={(e) => {
							fireUIAnalyticForFixMenuItem();
							onClose?.(e);
						}}
					>
						{formatMessage(viewAllDashboards)}
					</ViewAllEntityMenuItem>
				</MenuList>
			</MenuSection>
		</MenuListItem>
	);
};
